import { Application } from '../../services/Application';

const state = {
    countries: [],
    countriesAll: [],
    currencies: [],
    regions: [],
    docTypes: [],
    user: {},
    loading: false,
    loader: null
};

const actions = {
    fetch({ commit }) {
        commit('setLoading', true);
        Application.getOptions()
            .then(function (response) {

                commit("fetch", response.data);
            })
            .catch(function (error) {

            })
            .finally(function () {
                commit('setLoading', false)
            })
    },
    loaderRun({ commit }, color, canCancel = false) {
        commit('setLoader', Application.getLoader(color, canCancel));
    },
    hideLoader({ state }) {
        if (state.loader) {
            state.loader.hide();
            state.loader = null;
        }
    },
};

const mutations = {
    fetch(state, options) {
        state.countries = options.countries || [];
        state.countriesAll = options.countriesAll || [];
        state.currencies = options.currencies || [];
        state.regions = options.regions || [];
        state.docTypes = options.docTypes || [];
        state.user = options.user || {};
    },
    setLoader(state, loader) {
        state.loader = loader;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
};

const getters = {
    countries: state => state.countries || [],
    countriesAll: state => state.countriesAll || [],
    allCurrencies: state => state.currencies || [],
    docTypes: state => state.docTypes || [],
    regions: (state) => (country) => {
        return state.regions[country] || [];
    },
    currenciesByCountry: (state) => (country) => {
        return state.currencies[country] || [];
    },
    countryByCountryId: (state) => (id) => {
        let country = state.countries.find(x => x.C_Country_ID === id);
        return country ? country.Name : '';
    },
    isoByCountry: (state) => (id) => {
        let country = state.countries.find(x => x.C_Country_ID === id);
        return country ? country.CountryCode : '';
    },
    signedUserName: state => {
        let name = "";
        if (state.user) {
            name = (state.user.first_name || "") + " " + (state.user.last_name || "");
        }
        return name;
    },
    signedUserOrganization: state => {
        let name = "";
        if (state.user) {
            name = state.user.organization || "";
        }
        return name;
    },
    loading: state => state.loading
};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/Application.js